// extracted by mini-css-extract-plugin
export default {"avatarLink":"AvatarUser_avatarLink__KijLi","avatar":"AvatarUser_avatar__oCl3h"};